/* tslint:disable */
/* eslint-disable */
import { HttpClient, HttpContext } from '@angular/common/http';
import { Injectable } from '@angular/core';
import { Observable } from 'rxjs';
import { map } from 'rxjs/operators';

import { BaseService } from '../base-service';
import { ApiConfiguration } from '../api-configuration';
import { StrictHttpResponse } from '../strict-http-response';

import { ApiResponseString } from '../models/api-response-string';
import { setupCatalog } from '../fn/meta-catalog-api/setup-catalog';
import { SetupCatalog$Params } from '../fn/meta-catalog-api/setup-catalog';
import { submitCatalog } from '../fn/meta-catalog-api/submit-catalog';
import { SubmitCatalog$Params } from '../fn/meta-catalog-api/submit-catalog';
import { syncCatalog } from '../fn/meta-catalog-api/sync-catalog';
import { SyncCatalog$Params } from '../fn/meta-catalog-api/sync-catalog';

@Injectable({ providedIn: 'root' })
export class MetaCatalogApiService extends BaseService {
  constructor(config: ApiConfiguration, http: HttpClient) {
    super(config, http);
  }

  /** Path part for operation `submitCatalog()` */
  static readonly SubmitCatalogPath = '/v1/api/ui/meta-catalog/submit';

  /**
   * This method provides access to the full `HttpResponse`, allowing access to response headers.
   * To access only the response body, use `submitCatalog()` instead.
   *
   * This method sends `application/json` and handles request body of type `application/json`.
   */
  submitCatalog$Response(params: SubmitCatalog$Params, context?: HttpContext): Observable<StrictHttpResponse<string>> {
    return submitCatalog(this.http, this.rootUrl, params, context);
  }

  /**
   * This method provides access only to the response body.
   * To access the full response (for headers, for example), `submitCatalog$Response()` instead.
   *
   * This method sends `application/json` and handles request body of type `application/json`.
   */
  submitCatalog(params: SubmitCatalog$Params, context?: HttpContext): Observable<string> {
    return this.submitCatalog$Response(params, context).pipe(
      map((r: StrictHttpResponse<string>): string => r.body)
    );
  }

  /** Path part for operation `setupCatalog()` */
  static readonly SetupCatalogPath = '/v1/api/ui/meta-catalog/setup';

  /**
   * This method provides access to the full `HttpResponse`, allowing access to response headers.
   * To access only the response body, use `setupCatalog()` instead.
   *
   * This method sends `application/json` and handles request body of type `application/json`.
   */
  setupCatalog$Response(params: SetupCatalog$Params, context?: HttpContext): Observable<StrictHttpResponse<void>> {
    return setupCatalog(this.http, this.rootUrl, params, context);
  }

  /**
   * This method provides access only to the response body.
   * To access the full response (for headers, for example), `setupCatalog$Response()` instead.
   *
   * This method sends `application/json` and handles request body of type `application/json`.
   */
  setupCatalog(params: SetupCatalog$Params, context?: HttpContext): Observable<void> {
    return this.setupCatalog$Response(params, context).pipe(
      map((r: StrictHttpResponse<void>): void => r.body)
    );
  }

  /** Path part for operation `syncCatalog()` */
  static readonly SyncCatalogPath = '/v1/api/ui/meta-catalog/sync-products';

  /**
   * This method provides access to the full `HttpResponse`, allowing access to response headers.
   * To access only the response body, use `syncCatalog()` instead.
   *
   * This method doesn't expect any request body.
   */
  syncCatalog$Response(params: SyncCatalog$Params, context?: HttpContext): Observable<StrictHttpResponse<ApiResponseString>> {
    return syncCatalog(this.http, this.rootUrl, params, context);
  }

  /**
   * This method provides access only to the response body.
   * To access the full response (for headers, for example), `syncCatalog$Response()` instead.
   *
   * This method doesn't expect any request body.
   */
  syncCatalog(params: SyncCatalog$Params, context?: HttpContext): Observable<ApiResponseString> {
    return this.syncCatalog$Response(params, context).pipe(
      map((r: StrictHttpResponse<ApiResponseString>): ApiResponseString => r.body)
    );
  }

}
